import { useEffect, useState } from 'react';

// WebUI #222: Core-emailed security links carry a single-use credential in the
// query string. This hook
//   1. reads the token once (state initialiser, so a StrictMode re-run or a
//      re-render after the URL is cleaned cannot lose it),
//   2. strips it from the address bar with history.replaceState so it is not
//      left in history, bookmarks, screenshots or later Referer headers,
//   3. tells the browser to send no Referer from this page (defence in depth
//      alongside the nginx Referrer-Policy header, which is the primary control).
// It never logs or renders the token.
export const readTokenFromLocation = (search) => {
  const params = new URLSearchParams(search || '');
  return params.get('token') || '';
};

export const stripQueryFromAddressBar = () => {
  try {
    const { pathname } = window.location;
    window.history.replaceState(window.history.state, '', pathname);
  } catch (err) {
    // History API unavailable: the token stays in the URL but is still only
    // ever submitted after an explicit confirm click.
  }
};

export const useEmailedLinkToken = () => {
  const [token] = useState(() => readTokenFromLocation(window.location.search));

  useEffect(() => {
    stripQueryFromAddressBar();

    const meta = document.createElement('meta');
    meta.name = 'referrer';
    meta.content = 'no-referrer';
    meta.setAttribute('data-security-link', 'true');
    document.head.appendChild(meta);
    return () => {
      if (meta.parentNode) meta.parentNode.removeChild(meta);
    };
  }, []);

  return token;
};

export default useEmailedLinkToken;
